import { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { inactiveStudentDataAnalytcsTableHead } from './utils/inactiveStudentDataAnalytics';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getInactiveStudentDataAnalytcsTable } from '../../../../redux/features/crdMigrationSlice';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';

export default function InactiveStudentDataAnalytcs() {
  // normal variable
  const dispatch = useDispatch();

  /***********************************************/

  // react state
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  /***********************************************/

  // redux state

  const inactiveStudentDataAnalytcsTable = useSelector(
    (state) => state.crdMigration.inactiveStudentDataAnalytcsTable.data,
  );
  const loading = useSelector((state) => state.crdMigration.inactiveStudentDataAnalytcsTable.loading);

  /***********************************************/
  const styleString = `tbody tr:first-child {
    font-weight : 700 ;
    background : #b8ae89;
    }`;

  /***********************************************/

  // mounting Fetch
  useEffect(() => {
    dispatch(getInactiveStudentDataAnalytcsTable());
  }, [dispatch]);

  /***********************************************/

  return (
    <GlobalWrapper title={'Inactive Students Data Analytics'}>
      <GlobalTableNoPagination
        headers={inactiveStudentDataAnalytcsTableHead}
        rows={inactiveStudentDataAnalytcsTable?.analytics || []}
        permanentFirstRow={{
          ...(inactiveStudentDataAnalytcsTable?.totals ? inactiveStudentDataAnalytcsTable?.totals : {}),
          croName: 'Total',
          sl_no: '*',
        }}
        customeStyleString={styleString}
        tableState={tableState}
        setTableState={setTableState}
        loading={loading}
      />
    </GlobalWrapper>
  );
}
